import React from 'react';
import { useReveal } from '../lib/useReveal';
const PAIN_POINTS = ['Buscaste cursos y encontraste dos extremos — los que cuestan una fortuna y duran un fin de semana, o los gratuitos que no van a ningún lado', 'Empezaste a estudiar por tu cuenta pero la información contradictoria te confundió más de lo que te ayudó', 'Hiciste algún curso pero cuando llegó el momento de practicar de verdad — te bloqueaste. No sabías qué hacer exactamente', 'Querés que el Reiki sea parte de tu vida real — o incluso tu profesión — pero no tenés una hoja de ruta clara de cómo llegar ahí', 'Pagaste formaciones que prometían mucho y cumplieron poco', 'Te preguntás si realmente tenés lo que hace falta para practicar Reiki'];
export function ProblemSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#0a0a0a] py-12 md:py-16 px-5 sm:px-6 relative overflow-hidden border-t border-white/5" data-id="element-312">
      <div className="container mx-auto max-w-3xl relative z-10" data-id="element-313">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-314">
          <div className="text-center mb-8" data-id="element-315">
            <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6 leading-tight text-white" data-id="element-316">
              Si estás acá, algo en vos ya sabe que el Reiki es real.
            </h2>
            <div className="text-lg md:text-xl text-gray-300 space-y-4 font-medium" data-id="element-317">
              <p data-id="element-318">
                Que la energía existe. Que la sanación es posible. Que tenés
                algo para dar — o para darte primero a vos.
              </p>
              <p className="text-white" data-id="element-319">
                El problema no es la duda sobre el Reiki.
              </p>
              <p className="text-[#f0c040] font-bold" data-id="element-320">
                El problema es que nunca encontraste una formación que estuviera
                a la altura de lo que sentís.
              </p>
            </div>
          </div>

          <div className="max-w-2xl mx-auto" data-id="element-321">
            <h3 className="text-xl md:text-2xl font-serif font-bold text-[#f0c040] mb-8 text-center" data-id="element-322">
              ¿Te suena familiar alguna de estas situaciones?
            </h3>

            <ul className="space-y-6" data-id="element-323">
              {PAIN_POINTS.map((point, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-324">
                  <span className="text-[#eab308] text-xl leading-none mt-1 flex-shrink-0" data-id="element-325">
                    ✦
                  </span>
                  <span className="text-gray-300 text-base md:text-lg leading-relaxed" data-id="element-326">
                    {point}
                  </span>
                </li>)}
            </ul>

            <div className="mt-14 text-center" data-id="element-327">
              <p className="text-[#f0c040] font-serif italic text-xl md:text-2xl font-bold" data-id="element-328">
                "Si dijiste sí a alguna de esas — lo que viene fue creado
                exactamente para vos."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}